const schools = [
    {
        id: 'hkust',
        primary: 'Hong Kong University of Science and Technology',
        secondary: 'Bachelor of Computer Science and Engineering',
        content: [
            {
                id: 'fyp',
                title: 'Final Year Project',
                description: 'Security Compliance Checker Tool for Cloud Environment, focusing on managed Kubernetes Services'
            },
            {
                id: 'scholarship',
                title: 'Scholarship',
                description: 'Dean’s List, University Scholarship, HKSAR Government Scholarship Fund Reaching Out Award',
            }
        ]
    },
    {
        id: 'ctu',
        primary: 'Czech Technical University in Prague',
        secondary: 'Faculty of Information Technology',
        content: []
    }
]

export { schools }